export default "__VITE_PUBLIC_ASSET__b6454217__"